import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ModulePage from "@/pages/ModulePage";
import GlobalSearch from "@/pages/GlobalSearch";
import ActivityLog from "@/pages/ActivityLog";
import PartyLedger from "@/pages/PartyLedger";
import OvernightReport from "@/pages/OvernightReport";
import Emergency from "@/pages/Emergency";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import PaymentLedger from "@/pages/PaymentLedger";
import GatePassRegister from "@/pages/GatePassRegister";
import GatePassEditor from "@/pages/GatePassEditor";
import GatePassDetail from "@/pages/GatePassDetail";
import GatePassVerify from "@/pages/GatePassVerify";
import GatePass from "@/pages/GatePass";
import PublicVerify from "@/pages/PublicVerify";
import SecurityPortal from "@/pages/SecurityPortal";
import Security from "@/pages/Security";
import SafetyCheck from "@/pages/SafetyCheck";
import Settings from "@/pages/Settings";
import Finance from "@/pages/Finance";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<PublicVerify />} />
            <Route path="/verify/:number" element={<PublicVerify />} />
            <Route path="/gpi/security" element={<SecurityPortal />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/m/:resource" element={<Protected><ModulePage /></Protected>} />
            <Route path="/search" element={<Protected><GlobalSearch /></Protected>} />
            <Route path="/emergency" element={<Protected><Emergency /></Protected>} />
            <Route path="/users" element={<Protected><Users /></Protected>} />
            <Route path="/roles" element={<Protected><Roles /></Protected>} />
            <Route path="/ledger" element={<Protected><PaymentLedger /></Protected>} />
            <Route path="/finance" element={<Protected><Finance /></Protected>} />
            <Route path="/gate-pass" element={<Protected><GatePass /></Protected>} />
            <Route path="/gate-pass/verify" element={<Protected><GatePassVerify /></Protected>} />
            <Route path="/gate-pass/verify/:number" element={<Protected><GatePassVerify /></Protected>} />
            <Route path="/gate-pass/new" element={<Protected><GatePassEditor /></Protected>} />
            <Route path="/gate-pass/:id/edit" element={<Protected><GatePassEditor /></Protected>} />
            <Route path="/gate-pass/:id" element={<Protected><GatePassDetail /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/crm/projects/gpi/security" element={<Protected><Security /></Protected>} />
            <Route path="/crm/projects/gpi/safety" element={<Protected><SafetyCheck /></Protected>} />
            <Route path="/overnight-report" element={<Protected><OvernightReport /></Protected>} />
            <Route path="/party-ledger" element={<Protected><PartyLedger /></Protected>} />
            <Route path="/activity" element={<Protected><ActivityLog /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
